// extracted by mini-css-extract-plugin
module.exports = {"hero":"OfficeLandingHeader_hero__aepqp","search-fade-in":"OfficeLandingHeader_search-fade-in__oDq19"};